var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowExternalLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.651,14.35v8.48c0,0.279-0.11,0.529-0.29,0.71c-0.18,0.18-0.43,0.29-0.71,0.29c-0.55,0-1-0.45-1-1v-6.07l-19.6,19.59 c-0.19,0.2-0.45,0.301-0.7,0.301c-0.26,0-0.51-0.101-0.71-0.301c-0.39-0.39-0.39-1.02,0-1.409l19.6-19.601l-6.08,0.01 c-0.55,0-0.99-0.45-0.99-1c0-0.56,0.44-1,0.99-1h8.49c0.27,0,0.52,0.101,0.71,0.29C36.551,13.83,36.651,14.08,36.651,14.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExternalLink);
export default __webpack_public_path__ + "static/media/arrow-external-link.ad247375312fa48a86cbe7bbbd1f3914.svg";
export { ForwardRef as ReactComponent };